export const stats = [
  { value: '+300', label: 'Praxis-Seiten und Stundenbilder' },
  { value: '+1.200', label: 'Zufriedene Pilates-Trainer' },
  { value: '3.500+', label: 'Gesparte Planungsstunden' },
  { value: '98%', label: 'Empfehlungsrate' },
]

export const differenceStats = [
  { value: '6', label: 'Digitale Bände (PDF)' },
  { value: '+300', label: 'Stundenbilder & Sequenzen' },
  { value: '100%', label: 'Sofortiger Download' },
]

export const beforeItems = [
  'Stundenlanges Suchen nach Übungen auf 10 verschiedenen Websites oder Instagram',
  'Verwirrung im Kurs, weil klare visuelle Hilfen für komplexe Bewegungen fehlen',
  'Unsicherheit bei Sondergruppen (Schwangere/Senioren), ohne nachts Modifikationen zu recherchieren',
  'Kunden, die denken: „Das ist jede Woche das Gleiche“',
  'Kein System, um Fortschritte sichtbar zu machen und Teilnehmer langfristig zu halten',
]

export const afterItems = [
  '5 Minuten Vorbereitung und du gehst mit absoluter Sicherheit in den Kurs',
  'Moderne visuelle Karten, die die Aufmerksamkeit sofort fesseln',
  'Infografiken und Anatomie-Schemata in jeder Einheit integriert',
  'Progressionen, Varianten und Korrekturen zu 100% fertig vorbereitet',
  'Kunden, die deine Professionalität spüren und echte Ergebnisse sehen',
]

export const recognizeItems = [
  {
    emoji: '😰',
    text: 'Erklärungs-Angst: Im Kurs stehen und nicht wissen, wie man eine komplexe Bewegung (wie Spine Stretch oder Reformer Long Box) einfach macht',
  },
  {
    emoji: '⏱️',
    text: 'Geraubte Sonntage: Den ganzen Sonntag damit verbringen, Material vorzubereiten, das eigentlich schon fertig sein sollte',
  },
  {
    emoji: '🤷',
    text: 'Kreatives Chaos: Mühsames Suchen nach Übungsblättern, die wirklich hochwertig, visuell und professionell sind',
  },
  {
    emoji: '😴',
    text: 'Verlorene Kunden: Teilnehmer, die stagnieren, weil das Material nicht auf ihrem Niveau ist (zu leicht oder zu schwer)',
  },
]

export const packItems = [
  {
    emoji: '📚',
    title: '6 PDF-Bände nach Level & Geräten',
    text: 'Ein komplettes Curriculum von Matten-Grundlagen bis Reformer-Advanced',
  },
  {
    emoji: '🗺️',
    title: 'Visuelle Stundenbilder-Kits',
    text: 'Hochauflösende Karten zum Ausdrucken oder Projizieren',
  },
  {
    emoji: '✏️',
    title: '«Ready-to-Go» Cueing Scripts',
    text: 'Didaktische Tipps, die dir genau sagen, was du in jedem Moment sagen musst',
  },
  {
    emoji: '📐',
    title: 'Visual Pilates: Infografiken & Anatomie',
    text: 'Moderne Grafiken, die Biomechanik und Kraftlinien verständlich machen',
  },
  {
    emoji: '📊',
    title: 'Checklisten & Evaluation',
    text: 'Komplette Tools, um den Fortschritt deiner Kunden professionell zu messen',
  },
  {
    emoji: '🔑',
    title: 'Lösungsschlüssel',
    text: 'Schnelle Korrekturhilfen für einen stressfreien Unterricht',
  },
]

export const pageSamples = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/eQht7Kni3y3Skszx6RrREc/Captura-de-pantalla-2026-09-06-a-las-8.02.49_p._m..webp',
    level: 'Matte · Sequenz',
    title: 'Die 8-Minuten-Sequenz: Kein Stopp',
    caption:
      'Fünf Übungen von Single Leg Stretch bis Criss-Cross, jeweils mit Wiederholungen, Illustration und aktivierter Muskulatur — plus Atem-Hinweis für die Übergänge.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2d9NnwNe4RdeEyKBm6ycxs/Captura-de-pantalla-2026-09-06-a-las-8.04.12_p._m..webp',
    level: 'Jahresplanung · Alle Level',
    title: 'Dein Jahres-Programm: 52 Wochen auf einen Blick',
    caption:
      'Zwölf Monatsblöcke in drei Phasen — Aufbau, Vertiefung und Meisterung — mit klarem Schwerpunkt und Übungsfokus für jeden Monat.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gzmKEMg63DgP74qT3f4XAt/Captura-de-pantalla-2026-09-06-a-las-8.05.46_p._m..webp',
    level: 'Kleingeräte · Übungskarte',
    title: 'Roll Over on Arc',
    caption:
      'Bewegungsablauf in drei Fotos mit markierter Wirbelsäulen-Artikulation, didaktischer Erklärung, Modifikation und klar benannten Kontraindikationen.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/sRSoubWRrK3at9hS4Xp1Hm/Captura-de-pantalla-2026-09-06-a-las-8.11.26_p._m..webp',
    level: 'Studio-Tools · Vorlage',
    title: 'Medizinischer Fragebogen (Anamnese)',
    caption:
      'Fertige Vorlage zum Ausdrucken: Persönliche Daten, Diagnosen, Operationen, Schwangerschaft, Schmerz-Körperkarte und Arzt-Freigabe — rechtlich absichernd.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2EwJMycSRgvaxTta1uVATK/Captura_de_pantalla_2026-09-06_a_las_8.12.39_p.webp',
    level: 'Props · Stundenbild',
    title: 'Prop-Mix Flow — 20 Min Sequenz',
    caption:
      'Kompletter Stundenplan mit Magic Circle, Overball, Foam Roller und Resistance Band: sechs Stationen mit Foto, Übungsname und Minutenangabe.',
  },
]

export type Bonus = {
  title: string
  was: string
  text: string
  cover: string
  coverScale?: number
}

export const bonuses: Bonus[] = [
  {
    title: 'Pilates-Startprogramm',
    was: '29 €',
    text: 'Einstiegsprogramm für die ersten Trainingstage',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/03fa811c-201f-4c65-9327-6ec87821992f.jpg',
  },
  {
    title: 'Core-Checks für zu Hause',
    was: '19 €',
    text: 'Prüfe in Sekunden, ob die Körpermitte wirklich arbeitet',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/6074e9ea-f9ef-4964-804f-c9f3f0d34c4a.jpg',
  },
  {
    title: 'Dehn- und Beruhigungsroutine',
    was: '15 €',
    text: 'Kurze Abschlussroutine, die Verspannungen löst',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/063248ef-a9e1-4c8a-97a4-f3988002d935.jpg',
    coverScale: 0.82,
  },
  {
    title: 'Biomechanik der Wirbelsäule',
    was: '27 €',
    text: 'Sichere Protokolle für Bandscheibe, Skoliose & Lordose',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/a5925d73-8a37-4092-baef-69a88fcd0a51.jpg',
  },
  {
    title: 'Der Schwangerschafts-Kompass',
    was: '26 €',
    text: 'Sicher unterrichten in jedem Trimester',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/8c9ff2af-6c65-4042-baee-12210a88273f.jpg',
  },
]

export const offerRows = [
  { label: 'PILATES BEREIT™ (6 Digitale PDF-Bände)', value: '197 €' },
  { label: '5 Exklusive Boni', value: '116 €' },
]

export const testimonials = [
  {
    quote:
      'Endlich klare Karten und Sequenzen, denen meine Teilnehmer folgen können. Ich habe meine Wochenenden zurück!',
    name: 'Chiara M.',
    location: 'Berlin 🇩🇪',
  },
  {
    quote:
      'Der Sondergruppen-Guide hat alles verändert. Meine Kursteilnehmer sind motivierter denn je.',
    name: 'Elena V.',
    location: 'München 🇩🇪',
  },
]

export const faqs = [
  {
    q: 'Wie erhalte ich das Material?',
    a: 'Sofort nach der Zahlung per E-Mail als PDF zum Download.',
  },
  {
    q: 'Funktioniert es auch für Reformer-Kurse?',
    a: 'Ja, die Bände 4, 5 und 6 sind speziell für Reformer und Geräte-Pilates.',
  },
  {
    q: 'Ist es für Schwangere und Senioren geeignet?',
    a: 'Absolut, dank der visuellen Aufbereitung und des enthaltenen Schwangerschafts-Kompass (Bonus #5).',
  },
  {
    q: 'Gibt es monatliche Kosten?',
    a: 'Nein. Du zahlst einmal und das Material gehört für immer dir.',
  },
  {
    q: 'Darf ich die Seiten für meine Kurse ausdrucken?',
    a: 'Ja. Du darfst alle Stundenbilder, Übungskarten und Vorlagen unbegrenzt für deinen eigenen Unterricht ausdrucken und projizieren. Nur der Weiterverkauf der Dateien ist nicht erlaubt.',
  },
  {
    q: 'Brauche ich ein Studio oder Reformer-Geräte?',
    a: 'Nein. Die Bände 1 bis 3 funktionieren komplett auf der Matte, mit oder ohne Kleingeräte. Die Reformer-Inhalte kommen dazu, sobald du sie brauchst.',
  },
  {
    q: 'Bin ich als Einsteigerin damit nicht überfordert?',
    a: 'Im Gegenteil: Jede Einheit enthält fertige Cues, Progressionen und Korrekturen. Du folgst dem Stundenbild und bist in 5 Minuten vorbereitet.',
  },
  {
    q: 'Wie kann ich bezahlen?',
    a: 'Sicher per Kreditkarte oder den gängigen Online-Zahlungsmethoden im Checkout. Der Zugang wird direkt nach der Zahlung freigeschaltet.',
  },
]
